import { defaultStateReducer, FieldStateReducer } from "@/components/form"
import { useTranslations } from "next-intl"
import { ControllerFieldState } from "react-hook-form"

export function useTranslatedFieldErrorMessage(
  fieldState: ControllerFieldState,
  fieldStateReducer: FieldStateReducer = defaultStateReducer,
) {
  const t = useTranslations()

  const { errorMessage } = fieldStateReducer(fieldState)

  const translatedErrorMessage =
    errorMessage != null
      ? t(errorMessage.message, errorMessage.messageProps)
      : null

  return translatedErrorMessage
}
